export default "__VITE_ASSET__6d2583ec__"